import React from 'react';
import { ContentfulRichText } from '@jbhi-fi/apis/src/contentful/types';
import { styles } from './SupportArticle.css';
import { RichText } from '../RichText';
import { PlatformFunctionalityProvider } from '../PlatformFunctionality';

export interface SupportArticleProps {
  heading: string;
  content?: ContentfulRichText;
}

export const SupportArticle = ({ heading, content }: SupportArticleProps) => {
  return (
    <PlatformFunctionalityProvider>
      <h1>{heading}</h1>
      <div className={styles.richTextWrapper}>{content ? <RichText document={content} /> : null}</div>
    </PlatformFunctionalityProvider>
  );
};
